import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Divider,
  Stack,
  Text,
} from "@chakra-ui/react";
import PricingFooter from "@/components/pricingFooter";
import ConsumerGpuTable from "./consumerGPU";
import EnterpriseGpuPricingTable from "./enterpriseGPU";
import {PRICING_NOTES, GPU_TABLE_FOOTER_CONSTANTS} from "./constants";

export const GpuFooter = () => {
  return (
    <Box w="full">
      <Accordion allowToggle mb={8}>
        <AccordionItem borderRadius="md" border={"none"}>
          <AccordionButton p={4} w="fit-content">
            <Box fontWeight="bold" fontSize="lg" borderRadius={"md"} color="blue.600">
              *See Pricing Policies and Services
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4} border="1px solid" borderColor="gray.200">
            <Stack spacing={3}>
              {PRICING_NOTES.map((note, index) => (
                <Text fontSize={"md"} color="text.100" key={index}>
                  {note}
                </Text>
              ))}
            </Stack>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
      <PricingFooter {...GPU_TABLE_FOOTER_CONSTANTS} />
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

const GpuTables = () => {
  return (
    <Box>
      <Box mb={16}>
        <EnterpriseGpuPricingTable />
      </Box>
      <ConsumerGpuTable />
      <GpuFooter />
    </Box>
  );
};

export default GpuTables;
